export enum MeasurementUnitCodesEnum {
  Millimeters = 'MMT',
  Centimeters = 'CMT',
  Inches = 'INH',
  Feet = 'FOT',
  Meters = 'MTR',
  Yard = 'YRD',
  Kilometers = 'KMT',
  Miles = 'SMI',
  Milligrams = 'MGM',
  Grams = 'GRM',
  Kilograms = 'KGM',
  Tonne = 'TNE',
  KiloTonne = 'KTN',
  Pound = 'LBR',
  CubicMeters = 'MTQ',
  CubicCentimeters = 'CMQ',
  CubicInches = 'INQ',
  Liters = 'LTR',
  CubicFeet = 'FTQ',
  CubicYard = 'YDQ',
  Unknown = 'UNKNOWN',
}

export interface UnitSystemListModel {
  dimensionsUnitCode: MeasurementUnitCodesEnum;
  weightUnitCode: MeasurementUnitCodesEnum;
  volumeUnitCode: MeasurementUnitCodesEnum;
}
